import type { FC, PropsWithChildren } from "react";
import { createContext, useContext, useEffect, useState } from "react";

const VersionContext = createContext<string>("0.0.0");

async function fetchVersion(): Promise<string> {
  try {
    const response = await fetch("/version.json");
    const json = await response.json();
    return json.version;
  } catch (_error) {
    return "0.0.0";
  }
}

export const VersionProvider: FC<PropsWithChildren> = ({ children }) => {
  const [version, setVersion] = useState("0.0.0");

  useEffect(() => {
    fetchVersion()
      .then(setVersion)
      .catch(() => {});
  }, []);

  return (
    <VersionContext.Provider value={version}>
      {children}
    </VersionContext.Provider>
  );
};

export const useVersion = () => useContext(VersionContext);
